import {JbPageHeaderComponent} from "../../../core/component/jb-page-header.component";
import {useCallback, useEffect, useMemo, useState} from "react";
import {ProcessEntity} from "../../attendance/domain/entity/process.entity";
import {useProcessRepository} from "../../../../../domain/repository/process.repository";
import {Button, Col, Form, Input, Modal, Row, Select, Table} from "antd";
import {ClearOutlined, EyeOutlined, SearchOutlined} from "@ant-design/icons";
import {FullAttendanceComponent} from "../../attendance/component/full-attendance";
import {useClientRepository} from "../../client/domain/repository/client.repository";
import {AttendanceStatusComponent} from "../../attendance/component/attendance-status.component";

export function ListProcessPage(props: any) {
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState<any>();
  const [processes, setProcesses] = useState<ProcessEntity[]>();
  const [showAttendance, settShowAttendance] = useState<string>();
  const processRepo = useProcessRepository();
  
  const loadData = useCallback(() =>
      processRepo.search(limit,(page - 1) * limit, filter)
        .then(res => {
          setProcesses(res.data.data)
          setTotal(res.data.total);
        }),
    [page, limit, filter]
  )
  
  useEffect(() => {
    loadData()
  }, [page, limit, filter]);
  
  return (
    <>
      <JbPageHeaderComponent title={'Processos Judiciais'} description={'Gestão dos processos'} />
      
      <Filter onFilter={setFilter} />
      
      <Table
        dataSource={processes}
        loading={processRepo.loading}
        pagination={{
          total,
          pageSize: limit,
          onChange: (page, pageSize) => {
            setPage(page);
            setLimit(pageSize)
          },
          current: page
        }}
        columns={[
          {
            title: 'Código do Processo',
            dataIndex: 'code'
          },
          {
            title: 'Cliente',
            dataIndex: 'client',
            render: client => client?.name
          },
          // {
          //   title: 'Tribunal',
          //   dataIndex: 'processCourt',
          // },
          {
            title: 'Tipo / Sub Tipo',
            dataIndex: 'processType',
            render: (type, row) => `${type?.name} - ${row.processSubtype?.description}`,
          },
          {
            title: 'Autor',
            dataIndex: 'parts',
            render: parts => parts?.find((w: any) => w.partType.name == 'Autor')?.name
          },
          {
            title: 'Réu',
            dataIndex: 'parts',
            render: parts => parts?.find((w: any) => w.partType.name == 'Réu')?.name
          },
          {
            title: 'Status',
            dataIndex: 'attendanceStatus',
            render: status => <AttendanceStatusComponent status={status} />
          },
          {
            title: '',
            dataIndex: 'attendanceId',
            align: 'right',
            width: '5%',
            render: attendanceId => (
              <Button.Group>
                <Button
                  size={'small'}
                  icon={<EyeOutlined />}
                  type={'primary'}
                  onClick={() => settShowAttendance(attendanceId)}
                />
              </Button.Group>
            )
          }
        ]}
      />
      {
        showAttendance && (
          <Modal
            width={'90vw'}
            open
            onCancel={() => {
              settShowAttendance(undefined)
              loadData()
            }}
            footer={null}
          >
            <FullAttendanceComponent attendanceId={showAttendance}  />
          </Modal>
        )
      }
    </>
  )
}

function Filter(props: {
  onFilter: (values: any) => any
}) {
  const [clients, setClients] = useState<Array<any>>([]);
  const clientRepo = useClientRepository();
  
  useEffect(() => {
    clientRepo.list().then(res => setClients(res.data.map(cl => ({
      label: cl.name,
      value: cl.id
    }))))
  }, []);
  
  const [form] = Form.useForm();
  return (
    <Form onFinish={props.onFilter} >
      <Row justify={'end'} gutter={12}>
        <Col  span={6}>
          <Form.Item name={'partName'}>
            <Input placeholder={'Nome da parte'} />
          </Form.Item>
        </Col>
        <Col  span={4}>
          <Form.Item name={'code'}>
            <Input placeholder={'Código do Processo'} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name={'clientId'}>
            <Select placeholder={'Selecione um cliente'} allowClear options={clients} />
          </Form.Item>
        </Col>
        <Col>
          <Button
            htmlType={'submit'}
            type={'link'}
            icon={<SearchOutlined />}
          >
            Pesquisar
          </Button>
          <Button htmlType={'reset'} onClick={() => props.onFilter(undefined)} >
            Limpar
          </Button>
        </Col>
      </Row>
    </Form>
  )
}